import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../styles/ClientStats.css";

const clientData = [
  { name: "INDO COUNT INDUSTRIES LTD", location: "Kolhapur", state: "Maharashtra", persons: 650, logo: "/newlyaddedclients/indocount.png" },
  { name: "THE SUPREME INDUSTRIES LTD", location: "Sangli", state: "Maharashtra", persons: 200, logo: "/newlyaddedclients/supreme.png" },
  { name: "NELSON GLOBAL INDIA LTD.", location: "Dalwada", state: "Daman", persons: 450, logo: "/clients/Nelson-Global-1.png" },
  { name: "PRESICE CHEMI PHARMA LTD.", location: "Dindori", state: "Maharashtra", persons: 400, logo: "/clients/Precise-chemi-2.png" },
  { name: "SUZLON ENERGY LTD. PANCHAL", location: "Panchal", state: "Daman", persons: 300, logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD. CHADVEL NANDURBAR", location: "Nandurbar", state: "Maharashtra", persons: 1500, logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD.", location: "Dhabel", state: "Daman", persons: 200, logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD.", location: "Dalwada", state: "Daman", persons: 600, logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD.", location: "Beslor", state: "Daman", persons: 1100, logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD.", location: "Bhuj", state: "Gujarat", persons: 1200, logo: "/clients/Suzlon-3.png" },
  { name: "SUZLON ENERGY LTD.", location: "Anantapur", state: "Andhra Pradesh", persons: 2000, logo: "/clients/Suzlon-3.png" },
  { name: "EVEREST INDIA INDUSTRIES PVT. LTD.", location: "Dindori", state: "Maharashtra", persons: 700, logo: "/clients/Everest-industries-4.png" },
  { name: "EVEREST INDIA INDUSTRIES PVT. LTD.", location: "Dahej", state: "Gujarat", persons: 800, logo: "/clients/Everest-industries-4.png" },
  // { name: "KOLHAPUR STEEL (KIRLOSKAR GROUPS)", location: "Kolhapur", state: "Maharashtra", persons: 400, logo: "/clients/TKSL-kolhapur-stell-6.png" },
  { name: "Zobele India PVT. LTD.", location: "Panchal", state: "Daman", persons: 800, logo: "/clients/Zobele-7.png" },
  { name: "MENON AND MENON LTD.", location: "Kagal", state: "Maharashtra", persons: 600, logo: "/clients/Menon-and-menon-8.png" },
  { name: "MENON AND MENON LTD.", location: "Vikramnagar", state: "Maharashtra", persons: 1000, logo: "/clients/Menon-and-menon-8.png" },
  { name: "KIRLOSKAR BROTHERS LTD.", location: "Sangli", state: "Maharashtra", persons: 400, logo: "/clients/Kirloskar-brothers-9.png" },
  // { name: "GHATGE PATIL INDUSTRIES LTD.", location: "Kolhapur", state: "Maharashtra", persons: 800, logo: "/clients/Ghatge-patil-10.png" },
  { name: "ROCK WOOL INDIA LTD.INDIA", location: "Hyderabad", state: "Telangana", persons: 600, logo: "/clients/rockwool-11.png" },
  { name: "POLYCAB WIRES PVT LTD.", location: "Daman", state: "Daman", persons: 500, logo: "/clients/polycab-wires-13.png" },
  // { name: "POLYCAB WIRES PVT LTD. (WARE HOUSE)", location: "Daman", state: "Daman", persons: 200, logo: "/clients/polycab-wires-13.png" },
  { name: "EBIXCASH GLOBAL SERVICES PVT LTD.", location: "Mumbai", state: "Maharashtra", persons: 600, logo: "/clients/ebix-cash-global-14.png" },
  { name: "NIRMAL POLY PLAST PVT. LTD", location: "Angam (Unit-1), Gujarat", state: "Gujarat",persons: 500, logo: "/newlyaddedclients/Nirmal-Poly-Plastic.png"},
  { name: "PAPRO INDUSTRIES", location: "Sanjan, Gujarat",  state: "Gujarat", persons: 200, logo: "/newlyaddedclients/Papro-industries.png" },
  { name: " MANTRI METALLICS PVT LTD", location: "Mumbai, Kagal - MIDC",state: "Maharashtra", persons: 500, logo: "/newlyaddedclients/Mantri-metallics.png"},
  { name: " MANTRI Auto Components PVT. LTD", location: "Mumbai, Kagal - MIDC",state: "Maharashtra", persons: 200, logo: "/newlyaddedclients/Mantri-auto.png" } , 
  { name: "KINET RAILWAY SOLUTION LTD ", location: "Latur, Maharashtra",state: "Maharashtra", persons: 1500, logo: "/newlyaddedclients/Kinet-Railway-Solutions-1.png" }
];

const groupByState = (clients) => {
  const states = {};
  clients.forEach((client) => {
    if (!states[client.state]) states[client.state] = [];
    states[client.state].push(client);
  });
  return states;
};

const AnimatedNumber = ({ number }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const end = parseInt(number);
    if (start === end) return;
    let totalMilSecDur = 2000;
    let incrementTime = 100;
    let step = Math.ceil(end / (totalMilSecDur / incrementTime));
    let timer = setInterval(() => {
      start += step;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(start);
    }, incrementTime);
    return () => clearInterval(timer);
  }, [number]);
  return <>{count}</>;
};

const ClientStats = () => {
  const groupedClients = groupByState(clientData);
  const totalPersons = clientData.reduce((sum, c) => sum + c.persons, 0);
  const totalStates = Object.keys(groupedClients).length;
  const totalLocations = clientData.length;
  const uniqueCities = new Set(clientData.map(c => c.location)).size;

  return (
    <div className="client-stats-wrapper">
      <motion.div
        className="client-stats-hero"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        <h2>Empowering Industries Across India</h2>
        <p>We proudly serve over <span className="highlight"><AnimatedNumber number={totalPersons} /></span> individuals across major industrial hubs.</p>
      </motion.div>

      <motion.div
        className="stats-summary"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="stat-box"><h4>Total States/UTs Covered</h4><p><AnimatedNumber number={totalStates} /></p></div>
        <div className="stat-box"><h4>Total Unique Cities</h4><p>{uniqueCities}+</p></div>
        <div className="stat-box"><h4>Total Client Locations</h4><p><AnimatedNumber number={totalLocations} /></p></div>
        <div className="stat-box"><h4>Total Persons Served</h4><p><AnimatedNumber number={totalPersons} />+</p></div>
      </motion.div>

      <div className="timeline">
        <div className="line" />
        {Object.entries(groupedClients).map(([state, clients], index) => {
          const total = clients.reduce((sum, c) => sum + c.persons, 0);
          return (
            <motion.div
              key={state}
              className="timeline-entry"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="timeline-dot" />
              <div className="timeline-content">
                <h3>{state}</h3>
                <p className="state-total">Total Persons: {total}</p>
                <div className="client-list">
                  {clients
                        .slice() 
                        .sort((a, b) => b.persons - a.persons)
                        .map((client, idx) => (
                    <div className="client-card" key={idx}>
                      <img src={client.logo} alt={client.name} title={client.name} loading="lazy"/>
                      <div>
                        <strong>{client.name}</strong>
                        <p>{client.location}</p>
                        <span>{client.persons} persons</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ClientStats;
    